// extracted by mini-css-extract-plugin
export default {"P13-header":"P13Report_P13-header__KSM9x"};